import { useState } from "react";
import EditSvg from "../../assets/taiga-uikit/icons/edit-2.svg?react";
import { _aligeText, _colorText, _sizeText } from "../../core/core";
import "../texts/text.css";
import "./EditableText.css";

export const EditableText = ({
  size = _sizeText.hmp2,
  color = _colorText.default,
  aligeText = _aligeText.left,
  value = "",
  onClick,
  onBlur,
  onChange,
  minLength = 1,
  maxLength = Infinity,
}) => {
  const [isEditing, setEditing] = useState(false);
  const [internalValue, setInternalValue] = useState(value);

  const handleDoubleClick = () => {
    setEditing(true);
    onClick && onClick();
  };

  const handleBlur = () => {
    setEditing(false);
    onBlur && onBlur();
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    if (newValue.length >= minLength && newValue.length <= maxLength) {
      setInternalValue(newValue);
      onChange && onChange(e);
    }
  };

  return (
    <p
      onClick={handleDoubleClick}
      onBlur={handleBlur}
      className={`text text-${color} text-${size} text-${aligeText} text-edited-${true}`}
    >
      {isEditing ? (
        <input
          type="text"
          value={internalValue}
          onChange={handleChange}
          autoFocus
        />
      ) : (
        <>
          {internalValue} <EditSvg />
        </>
      )}
    </p>
  );
};
